module.exports = __webpack_public_path__ + "static/media/rappi-home@2x.83f3ba59.png";